<!-- eslint-disable prettier/prettier -->
<template>
  <div class="h-full w-full overflow-hidden">
    <!-- -->
    <div class="h-header-body z-50 sticky top-0 shadow-lg bg-white">
      <div class="flex justify-between items-center w-full h-full">
        <div class="logo hidden xl:block">
          <div class="flex justify-start items-center cursor-pointer p-2 pl-3">
            <div class="flex justify-start items-center p-1 cursor-pointer">
              <img
                src="../../assets/icon_svg/app_icon.svg"
                width="160"
                alt=""
                class="md:mr-2"
              />
            </div>
          </div>
        </div>
        <div
          class="btn-action justify-center flex items-center w-full xl:hidden"
        >
          <div
            v-for="(item, index) in items"
            :key="index"
            class="w-[122px] flex justify-center items-center item-menu"
            :class="{
              'border-indigo-600 border-b-4': selectedIndex === index,
            }"
            @click="selectItem(index)"
          >
            <img :src="item.icon" :width="item.width" alt="" />
          </div>
        </div>

        <div class="hidden lg:block">
          <div class="flex justify-start items-center cursor-pointer p-2 pl-3">
            <div
              class="flex justify-start gap-2 items-center p-1 cursor-pointer"
            >
              <div
                class="p-3 rounded-full text-bg hover:bg-stone-300"
                @click="onClickShowMessage()"
              >
                <img
                  src="../../assets/icon_svg/icon_message.svg"
                  width="15"
                  alt=""
                />
              </div>
              <div
                class="p-3 rounded-full text-bg hover:bg-stone-300"
                @click="onClickShowNotification()"
              >
                <img
                  src="../../assets/icon_svg/ic_noti.svg"
                  width="15"
                  alt=""
                />
              </div>
              <div
                @click="onClickShowAccount"
                v-if="renderAdmin.profiles.avatars.length !== 0"
                :style="{
                  'background-image': `url(${renderAdmin.profiles.avatars[0].meta.url})`,
                }"
                class="rounded-full size-image-small relative"
              >
                <img
                  class="absolute bottom-0 right-0 bg-white rounded-full"
                  src="../../assets/icon_svg/ic_show_profile.svg"
                  width="15"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="w-full z-50 h-full flex justify-center bg-app">
      <div class="lg:w-[100%] w-full h-full">
        <div class="flex justify-between w-full h-full pt-3">
          <div class="menu-left w-[400px] p-3 hidden 2xl:block">
            <MenuLeft @onShowDetailAdmin="onClickShowDetailAdmin"></MenuLeft>
          </div>

          <div class="body-center w-full lg:w-[100vh] justify-center flex p-3">
            <div class="feed-main w-[620px] h-[calc(100%-4rem)] relative">
              <router-view />

              <!-- <img
                @click="onClickNope"
                class="absolute bottom-0 left-0"
                src="../../assets/ic_tinder/ic_nope.svg"
                alt=""
              /> -->
            </div>
          </div>

          <div class="menu-right w-[400px] p-3 hidden lg:block">
            <MenuRight
              @onShowFormChat="onShowFormChat"
              @onShowDetailFriendNew="onShowDetailFriendNew"
              @onShowListFriend="onShowListFriend"
            ></MenuRight>
          </div>
        </div>
      </div>

      <div class="absolute bottom-0 right-0 flex items-center">
        <div v-for="(item, index) in renderMessageSelected" :key="index">
          <FormChat
            v-if="item.isShowForm"
            :listDetailMessage="item"
            @onShowDetailFriend="onShowDetailFriend"
          ></FormChat>
        </div>
      </div>
    </div>
  </div>
  <!--  -->
  <BhModelCard v-if="isShowViewDetailAdmin" @onHideModel="onHideModel">
    <div
      class="relative md:h-[700px] h-[600px] md:w-[38rem] w-[28rem] overflow-hidden"
    >
      <DetailAdmin :renderObjectCard="renderAdmin"></DetailAdmin>
    </div>
  </BhModelCard>

  <!-- isShowViewDetailUserNew -->
  <BhModelCard v-if="isShowViewDetailUserNew" @onHideModel="onHideModel">
    <div
      class="relative md:h-[700px] h-[600px] md:w-[38rem] w-[28rem] overflow-hidden z-99"
    >
      <DetailUser
        :renderObjectCard="userFriend"
        @onChangeChatWidthFriend="onChangeChatWidthFriend"
      ></DetailUser>
    </div>
  </BhModelCard>
  <!--  -->
  <bh-model v-if="isShowFormAccount" @onHideModel="onCancelModel">
    <div class="relative overflow-hidden">
      <!--  -->
      <account-view
        v-if="isShowAccountAdmin"
        @onChangeDeleteAccount="onChangeDeleteAccount"
        @onShowDetailAdmin="onShowDetailAdminAccount"
      ></account-view>

      <FormMessageView
        @onShowFormChat="onShowFormChat"
        v-if="isShowFormMessage"
      ></FormMessageView>
    </div>
  </bh-model>
  <!--  -->
  <BhModelCard v-if="isShowFormDelete">
    <div
      class="relative md:h-[200px] h-[300px] md:w-[30rem] w-[28rem] overflow-hidden z-20"
    >
      <div class="flex justify-center items-center font-bold text-lg">
        Are you sure you want to delete your account?
      </div>

      <div class="text-left p-5">
        <span class="text-sm">
          If you delete your account, you will permanently lose your profile,
          messages, photos, and matches. If you delete your account, this action
          cannot be undone.
        </span>
      </div>
      <div class="flex justify-end items-center">
        <button
          @click="onCancelDelete()"
          type="button"
          class="text-slate-400 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2"
        >
          Cancel
        </button>
        <BhButtonV1
          :nameButtonDefault="nameButtonDeleteAccount"
          :numberWeightBold="500"
          @onChangeActionButton="onClickDeleteAccount()"
        ></BhButtonV1>
      </div>
    </div>
  </BhModelCard>

  <BhModelCard v-if="isShowListFriends" @onHideModel="onHideModelFriend">
    <div
      class="relative md:h-[600px] h-[300px] md:w-[36rem] w-[28rem] overflow-hidden z-20"
    >
      <div class="text-title p-2 flex justify-center items-center">
        List new friends
      </div>
      <TabFriend @onShowDetailFriendChat="onShowDetailFriendChat"></TabFriend>
    </div>
  </BhModelCard>
</template>

<script>
import TabFriend from "../../components/form-profile-tab/tab-friend";
import DetailUser from "../../components/profile/view/detail-user";
import DetailAdmin from "../../components/profile/view/detail-admin";
import FormMessageView from "../../components/messages/form-message/form-message-view";
import BhButtonV1 from "../../control-ui/button/bh-button-v1";
import FormChat from "../../components/messages/form-chat";
import BhModelCard from "../../control-ui/model/bh-model-card";
import { mapMutations, mapActions } from "vuex";
import MenuLeft from "../../layout/menu-left/menu-left";
import MenuRight from "../../layout/menu-right/menu-right";
import BhModel from "@/control-ui/model/bh-model.vue";
import AccountView from "@/components/profile/logout/account-view.vue";
export default {
  components: {
    TabFriend,
    DetailUser,
    DetailAdmin,
    FormMessageView,
    BhButtonV1,
    FormChat,
    BhModelCard,
    MenuLeft,
    MenuRight,
    BhModel,
    AccountView,
  },
  name: "profile-index",

  data() {
    return {
      isShowLoad: true,
      loading: true,
      nameButtonDeleteAccount: "Delete Account",
      imageDefault: require("@/assets/icon_svg/image_default.jpg"),
      items: [
        {
          icon: require("@/assets/icon_svg/icon-park-solid_home.svg"),
          width: 28,
        },
        {
          icon: require("@/assets/icon_svg/ri_user-search-fill.svg"),
          width: 28,
        },
        { icon: require("@/assets/icon_svg/mdi_edit-box.svg"), width: 28 },
        { icon: require("@/assets/icon_svg/uiw_setting.svg"), width: 25 },
        { icon: require("@/assets/icon_svg/ic_package.svg"), width: 25 },
      ],
      selectedIndex: null,
      isShowViewDetailAdmin: false,
      isShowFormChat: false,

      isShowFormDelete: false,

      isShowFormAccount: false,
      isShowFormMessage: false,
      isShowFormNotification: false,
      isShowAccountAdmin: false,

      isShowViewDetailUserNew: false,

      isShowListFriends: false,
    };
  },

  computed: {
    renderTabActive() {
      return this.$store.state.feedModule.tabActive;
    },

    renderAdmin() {
      return this.$store.state.profileModule.userAdmin;
    },
    userFriend() {
      return this.$store.state.profileModule.userFriend;
    },

    renderMessageSelected() {
      debugger;
      return this.$store.state.messageModule.listMessageSelected;
    },
  },

  mounted() {
    this.selectItem(this.renderTabActive);
    const isShowHeaderAbout = false;
    this.setHideHeaderAbout(isShowHeaderAbout);
  },

  created() {
    this.getListFriendNews({
      pageSize: 100,
      currentPage: 0,
    });

    this.getListFriend({
      pageSize: 100,
      currentPage: 0,
    });

    this.getListChanelId({ pageSize: 100, currentPage: 0 });
  },

  methods: {
    ...mapMutations([
      "setHideHeaderAbout",
      "setTabActive",
      "setInformationUserFriend",
    ]),

    ...mapActions([
      "getListFriendNews",
      "getListChanelId",
      "getListFriend",
      "deleteAccountUser",
    ]),
    onClickDeleteAccount() {
      this.deleteAccountUser().then((response) => {
        localStorage.removeItem("oAuth2IdV2");
        localStorage.removeItem("tokenIdV2");
        localStorage.removeItem("idUser");

        this.$router.push({ path: "/" }).catch(() => {});
      });
      this.isShowFormDelete = false;
    },
    onCancelDelete() {
      this.isShowFormDelete = false;
    },
    onChangeDeleteAccount(val) {
      this.isShowFormDelete = val;
    },

    onShowDetailAdminAccount(val) {
      this.isShowViewDetailAdmin = val;
    },

    onClickShowMessage() {
      this.isShowFormAccount = true;
      this.isShowFormMessage = true;
      this.isShowAccountAdmin = false;
    },

    onClickShowNotification() {
      this.isShowFormNotification = true;
    },

    onClickShowAccount() {
      this.isShowFormAccount = true;
      this.isShowAccountAdmin = true;
      this.isShowFormMessage = false;
    },

    onCancelModel() {
      this.isShowFormAccount = false;
      this.isShowAccountAdmin = true;
      this.isShowFormMessage = false;
    },
    selectItem(index) {
      this.selectedIndex = index;
      this.setTabActive(index);

      if (index === 0) {
        localStorage.setItem("valueRouter", "feeds-view");

        this.$router.push({
          path: "/profile/feed",
          query: {
            namePage: "Feed",
          },
        });
      }
      if (index === 1) {
        localStorage.setItem("valueRouter", "explore-view");

        this.$router.push({
          path: "/profile/explore",
          query: {
            namePage: "Explore",
          },
        });
      }

      if (index === 2) {
        localStorage.setItem("valueRouter", "edit-profile-view");
        this.$router.push({
          path: "/profile/edit-profile",
          query: {
            namePage: "Edit profiles",
          },
        });
      }
      if (index === 3) {
        localStorage.setItem("valueRouter", "setting-profile-view");
        this.$router.push({
          path: "/profile/setting-profile",
          query: {
            namePage: "Settings",
          },
        });
      }
    },

    onClickShowDetailAdmin() {
      this.isShowViewDetailAdmin = true;
    },

    onHideModel() {
      this.isShowViewDetailAdmin = false;
      this.isShowViewDetailUserNew = false;
    },

    onClickNope() {
      this.isShowLoad = true;

      setTimeout(() => {
        this.isShowLoad = false;
      }, 1000);
    },

    onShowFormChat(val) {
      this.isShowFormChat = val;
      this.isShowFormAccount = false;
    },

    onShowDetailFriend(val) {
      this.isShowViewDetailAdmin = true;
    },

    onShowDetailFriendNew(val) {
      this.isShowViewDetailUserNew = true;
    },

    onChangeChatWidthFriend(val) {
      this.isShowViewDetailUserNew = false;
    },

    onShowListFriend(val) {
      this.isShowListFriends = val;
    },

    onShowDetailFriendChat(val) {
      this.setInformationUserFriend(val);
      this.isShowViewDetailUserNew = true;
      this.isShowListFriends = false;
    },

    onHideModelFriend() {
      this.isShowListFriends = false;
    },
  },
};
</script>

<style lang="scss">
.bg-app {
  background-color: #f0f2f5;
  color: #050505;
}
.h-header-body {
  height: 57px;
}

.logo-admin:hover {
  background-color: #e4e6e9;
  border-radius: 10px;
}

.size-image-small {
  width: 40px;
  height: 40px;
  border: 0.5px solid #e4e8ee;
  background-size: cover; /* Hiển thị ảnh với tỷ lệ ảnh gốc và điều chỉnh kích thước để không cắt bớt */
  background-position: center; /* Canh giữa ảnh */
  background-repeat: no-repeat; /* Không lặp lại ảnh */
}

.item-menu {
  padding: 13px;
}

.ripple {
  width: 2rem;
  height: 2rem;
  margin: 2rem;
  border-radius: 50%;
  border: 0.3rem solid #979fd0;
  transform: translate(50%);
  animation: 1s ripple ease-out infinite;
}

@keyframes ripple {
  from {
    transform: scale(0);
    opacity: 1;
  }

  to {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
